import {
    AnySource,
    BookingSourceType,
    NotificationSourceType,
    SavedItem,
} from "modules/FunnelAnalytics/interfaces"
import {
    createBookingSource,
    itemToString,
    toItem,
} from "modules/FunnelAnalytics/FunnelStorageUtils"
import { APP_STATUSES } from "utils/AppStatusContext"
import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"

/*
 * Тестовые сценарии:
 * Профиль -> Бронирование = ProfileSource
 * Анкета (-> Профиль) -> Бронирование = SurveyResultsSource
 * Подборка из почты (-> Профиль) -> Бронирование = EmailResultsSource
 * Подборка психологов (-> Профиль) -> Бронирование = PsyCollectionSource
 * Подборка (старая версия) (-> Профиль) -> Бронирование = ListSource
 * Каталог (-> Профиль) -> Бронирование = CatalogSource { parent: "unknown" }
 * Анкета -> Каталог (-> Профиль) -> Бронирование = CatalogSource { parent: "survey_results" }
 * Подборка психологов -> Каталог (-> Профиль) -> Бронирование = CatalogSource { parent: "psy_collection" }
 * Подборка (старая версия) -> Каталог (-> Профиль) -> Бронирование = CatalogSource { parent: "list" }
 * Подборка из почты -> Каталог (-> Профиль) -> Бронирование = CatalogSource { parent: "results_from_email" }
 * ЛК клиента (-> Профиль) -> Бронирование = ClientAccountSource
 * */

export class FunnelStorage {
    private static instance: FunnelStorage
    storage: StorageWrapper | undefined
    static KEY = "alterFunnel"

    private constructor() {
        this.storage = isStorageAvailable ? new StorageWrapper(window.localStorage) : undefined
        return FunnelStorage.instance
    }

    static getInstance(): FunnelStorage {
        if (!FunnelStorage.instance) {
            FunnelStorage.instance = new FunnelStorage()
        }

        return FunnelStorage.instance
    }

    saveItem(
        status: BookingSourceType,
        collectionId?: string,
        emailSource?: NotificationSourceType,
        express?: boolean
    ) {
        const toSave: SavedItem = { status }
        if (collectionId) {
            toSave.collectionId = collectionId
        }
        if (emailSource) {
            toSave.emailSource = emailSource
        }
        if (express) {
            toSave.express = express
        }
        const saved = this.getItems()
        if (saved.length === 0) {
            return this.storage?.storeArray(FunnelStorage.KEY, [itemToString(toSave)])
        }
        const last = saved[saved.length - 1]
        if (last.status !== status) {
            this.storage?.storeArray(
                FunnelStorage.KEY,
                saved.map(itemToString).concat(itemToString(toSave))
            )
        }
    }

    private getItems(): SavedItem[] {
        return (this.storage?.getArray<string>(FunnelStorage.KEY) ?? []).map(toItem)
    }

    getBookingSource(): AnySource {
        const saved = this.getItems().reverse()
        if (saved.length === 0) return createBookingSource()
        const index: Record<string, number> = {
            last: 0,
            parent1: 1,
        }
        if (saved[index.last].status === APP_STATUSES.profile && saved[index.parent1]) {
            Object.keys(index).forEach((key) => ++index[key])
        }
        const source = saved[index.last]
        const parent1 = saved[index.parent1]
        return createBookingSource(source, parent1)
    }

    cleanStorage() {
        this.storage?.remove(FunnelStorage.KEY)
    }
}
